export default __webpack_public_path__ + "static/media/lorcana_iconic.49f3f733.svg";